import { Analytics } from "@vercel/analytics/react";
import { HelmetProvider } from "react-helmet-async";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import ScrollToTop from "./Components/ScrollToTop";
import ChatWidget from "./Components/ChatWidget";
import CookieConsent, { useAnalyticsConsent } from "./Components/CookieConsent";
import SEO from "./Components/SEO/SEO";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import ContactPage from "./pages/ContactPage";
import CareersPage from "./pages/CareersPage";
import WorkPage from "./pages/WorkPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import "./App.css";

function ConsentAwareAnalytics() {
  const allowed = useAnalyticsConsent();
  if (!allowed) return null;
  return <Analytics />;
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <SEO />
        <ConsentAwareAnalytics />
        <CookieConsent />
        <ChatWidget />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/work" element={<WorkPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
